module.exports = __webpack_public_path__ + "img/EstudianteNULL.9fbc7a13.png";